module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/assessment_achievements/5_905a17c4a4bcb6b9b9c5c8af4b50885c.png";